module.exports = __webpack_public_path__ + "static/media/carousel-slide-modal-0.010c6d2a.webp";